import React, { useState } from "react";

const UploadRepository = (props) => {
    const { repoDocs, setSelectedRepoDocs } = props;
    const [selectedDocs, setSelectedDocs] = useState([]);
    const handleSelectDoc = ({ currentTarget }) => {
        const id = currentTarget.name.split("_")[1];
        const existingDocs = [...selectedDocs];
        const index = existingDocs.findIndex((x) => x.id === parseInt(id));
        if (currentTarget.checked) {
            const obj = repoDocs.filter((x) => x.id === parseInt(id));
            if (obj.length > 0) existingDocs.push(obj[0]);
        } else {
            existingDocs.splice(index, 1);
        }
        setSelectedDocs(existingDocs);
        setSelectedRepoDocs(existingDocs)
    };
    return <>
        <div className="col-md-12 text-right mb-2">
            <a className="btn btn-outline-default btn-sm "
                href={`${process?.env?.REACT_APP_DDRMS_PORTAL_BASEURL}`} target="_blank">
                <i class="fa fa-plus" aria-hidden="true"></i> Add Document
            </a>
        </div>
        <div className="col-md-12 form-group">
            <div className="table-responsive bg-white border" style={{ maxHeight: "270px", overflow: "auto" }}>
                <table className="table align-items-center table-flush table-hover table-striped">
                    <thead className="thead-light">
                        <tr>
                            <th>Select</th>
                            <th>ID</th>
                            <th>Document Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        {repoDocs.length === 0 && <tr>
                            <td colSpan={3} align="center">Fetching DDRMS Repository...</td>
                        </tr>}
                        {repoDocs.map((item) => (
                            <tr>
                                <td>
                                    <input
                                        type="checkbox"
                                        name={`chkSelect_${item.id}`}
                                        id={`chkSelect_${item.id}`}
                                        onChange={handleSelectDoc}
                                    />
                                </td>
                                <td>{item.id}</td>
                                <td>
                                    <button className="btn btn-link pl-0 btn-sm">
                                        {item.name}
                                    </button>
                                </td>

                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    </>
}

export default UploadRepository;